module.exports = __webpack_public_path__ + "static/media/moon.73e8f14c.svg";